module.exports = __webpack_public_path__ + "img/ueber-mich-2_960.6ef1acb9.jpg";